import { AgGridState } from '@/models/views/AgGrid'

const OPERADOR_TEXTO: Record<string, string> = {
	contains: 'contem',
	notContains: 'naoContem',
	equals: 'igual',
	notEqual: 'diferente',
	startsWith: 'comecaCom',
	endsWith: 'terminaCom',
	blank: 'vazio',
	notBlank: 'naoVazio',
}

const OPERADOR_NUMERO: Record<string, string> = {
	equals: 'igual',
	notEqual: 'diferente',
	greaterThan: 'maior',
	greaterThanOrEqual: 'maiorIgual',
	lessThan: 'menor',
	lessThanOrEqual: 'menorIgual',
	inRange: 'entre',
	blank: 'vazio',
	notBlank: 'naoVazio',
}

function ehColunaDoRelatorio(colId: any): boolean {
	return typeof colId === 'string' && !!colId && !colId.startsWith('ag-Grid-')
}

function converterCondicao(field: string, condicao: any): any | null {
	if (!condicao) return null
	const mapa = condicao.filterType === 'number' ? OPERADOR_NUMERO : OPERADOR_TEXTO
	const operador = mapa[condicao.type]
	if (!operador) return null
	return {
		field,
		operador,
		valor: condicao.filter != null ? String(condicao.filter) : '',
		valor2: condicao.filterTo != null ? String(condicao.filterTo) : '',
	}
}

function converterFiltros(filterModel: any): any[] {
	const filtros: any[] = []
	Object.keys(filterModel || {}).filter(ehColunaDoRelatorio).forEach(field => {
		const modelo = filterModel[field]
		if (!modelo) return
		if (Array.isArray(modelo.conditions)) {
			if (modelo.operator === 'OR' && modelo.conditions.length > 1) return
			modelo.conditions.forEach((c: any) => {
				const f = converterCondicao(field, { filterType: modelo.filterType, ...c })
				if (f) filtros.push(f)
			})
			return
		}
		const f = converterCondicao(field, modelo)
		if (f) filtros.push(f)
	})
	return filtros
}

export function ehTemplateDoConstrutor(preset: AgGridState): boolean {
	return !!(preset.presetSalvo && preset.presetSalvo.tipo === 'relatorio-pdf')
}

export function converterVisaoLegada(preset: AgGridState): any {
	const estado = preset.presetSalvo || {}
	const agrupadas: string[] = ((estado.rowGroup && estado.rowGroup.groupColIds) || []).filter(ehColunaDoRelatorio)
	const ocultos: string[] = ((estado.columnVisibility && estado.columnVisibility.hiddenColIds) || [])
		.filter(ehColunaDoRelatorio)
		.filter((field: string) => !agrupadas.includes(field))
	const ordenadas: string[] = ((estado.columnOrder && estado.columnOrder.orderedColIds) || []).filter(ehColunaDoRelatorio)
	const ordenacao = ((estado.sort && estado.sort.sortModel) || []).find((s: any) => ehColunaDoRelatorio(s.colId))

	let pivot: any = null
	const colunaPivot = ((estado.pivot && estado.pivot.pivotColIds) || []).find(ehColunaDoRelatorio)
	const valores: string[] = ((estado.aggregation && estado.aggregation.aggregationModel) || [])
		.map((a: any) => a.colId)
		.filter(ehColunaDoRelatorio)
	if (estado.pivot && estado.pivot.pivotMode && colunaPivot && agrupadas.length && valores.length) {
		pivot = {
			colunaField: colunaPivot,
			linhas: agrupadas.map(field => ({ field, header: field })),
			valores: valores.map(field => ({ field, header: field, moeda: false })),
		}
	}

	return {
		...preset,
		visaoLegada: true,
		presetSalvo: {
			tipo: 'relatorio-pdf',
			config: {
				ordem: ordenadas.filter(field => !ocultos.includes(field)),
				ocultos,
				quebraFields: pivot ? [] : agrupadas,
				ordenarField: ordenacao ? ordenacao.colId : null,
				ordenarDir: ordenacao && ordenacao.sort === 'desc' ? 'desc' : 'asc',
				pivot,
				formato: 'tabela',
				filtros: converterFiltros(estado.filter && estado.filter.filterModel),
			},
		},
	}
}
